// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2ff8p","title":"ClientCherryInfo_title__7FILq","itemText":"ClientCherryInfo_itemText__2V4M8"};